/**
 * EnergyConnect.WebApi | v1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const MeteringPointType = {
    NotSpecified: 'NotSpecified',
    VEProduction: 'VEProduction',
    Analysis: 'Analysis',
    SurplusProductionGroup: 'SurplusProductionGroup',
    NetProduction: 'NetProduction',
    SupplyToGrid: 'SupplyToGrid',
    ConsumptionFromGrid: 'ConsumptionFromGrid',
    WholesaleServices: 'WholesaleServices',
    OwnProduction: 'OwnProduction',
    NetFromGrid: 'NetFromGrid',
    NetToGrid: 'NetToGrid',
    TotalConsumption: 'TotalConsumption',
    GridLossCorrection: 'GridLossCorrection',
    ElectricalHeating: 'ElectricalHeating',
    InternalUse: 'InternalUse',
    Consumption: 'Consumption',
    Production: 'Production',
    Exchange: 'Exchange',
    NettoConsumption: 'NettoConsumption',
    OtherConsumption: 'OtherConsumption',
    OtherProduction: 'OtherProduction',
    ExchangeReactiveEnergy: 'ExchangeReactiveEnergy',
    EffectPayment: 'EffectPayment',
    CollectiveNetProduction: 'CollectiveNetProduction',
    CollectiveNetConsumption: 'CollectiveNetConsumption',
} as const;
export type MeteringPointType = typeof MeteringPointType[keyof typeof MeteringPointType];

